import React from "react";
import { ReactComponent as EmptyStateIcon } from "../../../assets/images/IllustrationSmallEmpty.svg";
import "./dropdownEmptyState.less";
import { Loader } from "../../components/Loader";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../utils/translationUtils";

interface DropdownEmptyStateProps {
  isloading?: boolean;
}

export const DropdownEmptyState = ({
  isloading = false,
}: DropdownEmptyStateProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div className="dropdown-empty-state">
      {isloading ? (
        <Loader data-testid="loader" mask={false} />
      ) : (
        <>
          <p>{formatTranslation(t("shared.noResults"))}</p>
          <EmptyStateIcon className="icon-empty-state" />
        </>
      )}
    </div>
  );
};
